import React, { useState, useEffect } from "react";

import ModalImage from "react-modal-image";
import api from "../../services/api";

// `onAbrir` manda o clique para o visualizador da conversa (zoom, girar, setas
// entre os anexos). Sem ele, cai no lightbox simples do react-modal-image —
// que é o que sobrava na conversa e não tinha nenhum dos controles.
const ModalImageCors = ({ imageUrl, onAbrir }) => {
	const [blobUrl, setBlobUrl] = useState("");
	const [erro, setErro] = useState(false);

	useEffect(() => {
		if (!imageUrl) return undefined;

		let url = "";

		const carregar = async () => {
			try {
				const { data, headers } = await api.get(imageUrl, {
					responseType: "blob",
				});
				url = window.URL.createObjectURL(
					new Blob([data], { type: headers["content-type"] })
				);
				setBlobUrl(url);
			} catch (err) {
				setErro(true);
			}
		};

		carregar();

		// Sem o revoke o blob fica retido enquanto a aba estiver aberta.
		return () => {
			if (url) window.URL.revokeObjectURL(url);
		};
	}, [imageUrl]);

	if (erro) {
		return (
			<div className="flex h-[200px] w-[250px] items-center justify-center rounded-lg bg-muted text-xs text-muted-foreground">
				Não foi possível carregar a imagem
			</div>
		);
	}

	if (!blobUrl) {
		return (
			<div className="h-[200px] w-[250px] animate-pulse rounded-lg bg-muted" />
		);
	}

	if (onAbrir) {
		return (
			<img
				src={blobUrl}
				alt="Imagem enviada na conversa"
				onClick={onAbrir}
				className="h-[200px] w-[250px] cursor-zoom-in rounded-lg object-cover"
			/>
		);
	}

	return (
		<ModalImage
			className="h-[200px] w-[250px] rounded-lg object-cover"
			smallSrcSet={blobUrl}
			medium={blobUrl}
			large={blobUrl}
			alt="Imagem enviada na conversa"
		/>
	);
};

export default ModalImageCors;
